import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { applyDocumentTheme, readStoredTheme, resolveAuthenticationTheme } from '../../../utilities/themePreference';
import { WaiveraLogo } from '../../ui/Logo/WaiveraLogo';
import Tooltip from '../../ui/Tooltip/Tooltip';
import { isPublicResourcePath } from './publicResourcePaths';
import './PublicResourceDirectory.css';
const PublicResourceDirectory = React.lazy(() => import('./PublicResourceDirectory'));

export { isPublicResourcePath };
export const PUBLIC_RESOURCE_THEME_KEY = 'waivera:publicResourcesTheme';
export default function PublicResourceRouteSwitch({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [theme, setTheme] = useState(() => readStoredTheme(PUBLIC_RESOURCE_THEME_KEY) ?? resolveAuthenticationTheme());
  const publicPath = isPublicResourcePath(location.pathname);
  useEffect(() => { if (publicPath) applyDocumentTheme(theme); }, [publicPath, theme]);
  if (!publicPath) return <>{children}</>;
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark'; setTheme(next);
    try { localStorage.setItem(PUBLIC_RESOURCE_THEME_KEY,next); } catch { /* Optional preference. */ }
  };
  return <div className={`public-resources-shell ${theme === 'dark' ? 'dark' : ''}`}>
    <header className="pr-site-header"><Link to="/public/resources" className="pr-brand" aria-label="Waivera resource directory"><span className="pr-brand-mark"><WaiveraLogo /></span><span className="pr-brand-label">Resources</span></Link>
      <nav aria-label="Resource directory navigation"><Tooltip content={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}><button type="button" onClick={toggle} aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}>{theme === 'dark' ? <Sun size={19} /> : <Moon size={19} />}</button></Tooltip><Link to="/login">Sign in</Link></nav>
    </header><React.Suspense fallback={<main className="pr-main"><p role="status">Loading resource directory…</p></main>}><Routes><Route path="/public/resources/*" element={<PublicResourceDirectory />} /></Routes></React.Suspense>
    <footer className="pr-footer">Free community resource information · Powered by{"\u00a0"}Waivera</footer>
  </div>;
}
